var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.40928 0.00196598 2.88425 0.66484 1.75944 1.84321C0.634626 3.02159 0.001883 4.61924 6.38338e-06 6.28571C-0.00189883 7.64756 0.422723 8.97245 1.20873 10.0571C1.20873 10.0571 1.37237 10.2829 1.3991 10.3154L6 16L10.6031 10.3126C10.6271 10.2823 10.7913 10.0571 10.7913 10.0571L10.7918 10.0554C11.5774 8.97121 12.0019 7.64693 12 6.28571C11.9981 4.61924 11.3654 3.02159 10.2406 1.84321C9.11575 0.66484 7.59072 0.00196598 6 0ZM6 8.57143C5.56848 8.57143 5.14665 8.43737 4.78785 8.18622C4.42905 7.93506 4.1494 7.57808 3.98426 7.16042C3.81913 6.74276 3.77592 6.28318 3.86011 5.83979C3.94429 5.39641 4.15209 4.98913 4.45722 4.66947C4.76236 4.34981 5.15112 4.13211 5.57435 4.04392C5.99758 3.95572 6.43627 4.00099 6.83494 4.17399C7.23362 4.34699 7.57437 4.63996 7.81411 5.01584C8.05385 5.39172 8.18182 5.83364 8.18182 6.28571C8.18109 6.89169 7.95099 7.47263 7.54198 7.90112C7.13297 8.32961 6.57843 8.57067 6 8.57143Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.b664d88d9c331fc0a38a2565c89e5a3b.svg";
export { ForwardRef as ReactComponent };